import { LvgAssetsSelector } from 'components/Organisms/LvgAssetsDropDown.js'
import { AssetInfoButton, AssetsSelectorCSS } from './AssetsSelectorCSS.styled'
import { useYoloModal } from 'lib/yoloModals/useYoloModal'
import { useLvgState } from 'hooks/games/lvg/useLvgState'

export const AssetsSelector = () => {
  const { updateModal } = useYoloModal()
  const { activeAsset } = useLvgState()

  const showAssetInfo = () => {
    const assetInfoModalObj = {
      show: true,
      id: 'assetInfo',
      props: { assetInfo: activeAsset },
      backdropBlurred: false,
    }
    updateModal(assetInfoModalObj)
  }

  return (
    <AssetsSelectorCSS>
      <LvgAssetsSelector />
      <AssetInfoButton
        data-hint={'Asset Info'}
        className='hint--rounded hint--small hint--top'
        onClick={() => showAssetInfo()}
      />
    </AssetsSelectorCSS>
  )
}
